import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modalBody"]

  showAddForm(event) {
    var inscriptionWordId = event.target.getAttribute('data-inscription-word-id');

    fetch(`/admin/quick_add?inscription_word_id=${inscriptionWordId}/`)
      .then(response => response.text())
      .then(html => {
        this.modalBodyTarget.innerHTML = html;
      });
  }

  showEditForm(event) {
    var inscriptionWordId = event.target.getAttribute('data-inscription-word-id');
    var wordId = event.target.getAttribute('data-word-id');

    fetch(`/admin/${wordId}/quick_edit?inscription_word_id=${inscriptionWordId}/`)
      .then(response => response.text())
      .then(html => {
        this.modalBodyTarget.innerHTML = html;
      });
  }
}